import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {LoginService} from "./login.service";
import {AuthService} from "../auth.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  loginForm;

  constructor(
    private newService: LoginService,
    private auth:AuthService,
    private router: Router,
  ) {
      const isLogin = this.auth.authenticateAccount();
      if(isLogin){
          this.router.navigate(['/']);
      }
  }

  createLoginForm(){
    this.loginForm = new FormGroup({
      email_address: new FormControl("",[
        Validators.required,
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$")
      ]),
      password: new FormControl("",[
        Validators.required,
        Validators.minLength(3)
      ])
    });
  }

  ngOnInit() {
    this.createLoginForm();
  }

  onSubmit(loginValue) {
    this.newService.loginCall(loginValue.email_address,loginValue.password).then(UserData => {
      console.log('======RESPONE GET======');
      if(UserData['code'] === 200){
        console.log(UserData['message']);
        console.log(UserData['data']);
        localStorage.setItem('loginuser',JSON.stringify(UserData['data']));
        this.router.navigate(['/home']);
      }else{
        alert(UserData['message'])
        console.log(UserData['message']);
      }
    }).catch(err => {
      console.log( 'err============>', err );
    });


  }

}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/login/login.component.ts